import { makeVar } from "shared/providers/apollo/apollo.package";

/**
 * Control sidebar expanded state
 */

export const sidebarExpandedVar = makeVar(false);

export const resetSidebarExpandedVar = () => sidebarExpandedVar(false);
